module.exports = __webpack_public_path__ + "static/media/cleaner_center_ logo.49e2643a.jpg";